import { render } from "./gallery-page.vue?vue&type=template&id=509e02f4"
import script from "./gallery-page.vue?vue&type=script&lang=ts"
export * from "./gallery-page.vue?vue&type=script&lang=ts"

import "./gallery-page.vue?vue&type=style&index=0&id=509e02f4&lang=css"
script.render = render

export default script